import ConfirmDialog from 'further-ui/components/ConfirmDialog';
import { Disclosure } from 'further-ui/hooks';
import { FC } from 'react';

type DataLossWarningModalProps = {
  disclosure: Disclosure;
  onConfirm: () => void;
  onCancel: () => void;
  message: string;
};

const DataLossWarningModal: FC<DataLossWarningModalProps> = ({
  disclosure,
  onConfirm,
  onCancel,
  message,
}) => (
  <ConfirmDialog
    open={disclosure.isOpen}
    onClose={() => {
      onCancel();
      disclosure.onClose();
    }}
    title="Warning"
    content={message}
    actions={{
      confirm: {
        label: 'Remove',
        onClick: () => {
          onConfirm();
          disclosure.onClose();
        },
      },
      cancel: {
        label: 'Go back',
        onClick: () => {
          onCancel();
          disclosure.onClose();
        },
      },
    }}
  />
);

export default DataLossWarningModal;
